<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>PayPal Payment Requests</p>
          <!-- <Filters /> -->
        </div>
        <Table />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
// import Filters from '../components/paypal/Filters'
import Table from '../components/paypal/Table'
import { mapState } from 'vuex'

export default {
  components: {
    // Filters,
    Table
  },

  computed: {
    ...mapState('vcPayPal', ['loading'])
  }
}
</script>
